export default "__VITE_ASSET__dAn9NctC__"